export const DealerLocationStatusTypes = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
};
